// import React from 'react';
// import { ChevronLeft, Home } from 'lucide-react';

// export const ServicePageHeader = ({ title, description }) => {
//   return (
//     <section className="relative pt-32 pb-20 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 border-b border-slate-900 overflow-hidden" dir="rtl">
//       {/* التأثيرات الخلفية الفاخرة (توهج ذهبي خفيف) */}
//       <div className="absolute top-0 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none"></div>
//       <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-slate-800/10 rounded-full blur-3xl pointer-events-none"></div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          
//           {/* عنوان الخدمة والوصف */}
//           <div className="max-w-3xl">
//             <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 tracking-wide leading-tight">
//               {title}
//             </h1>
//             {description && (
//               <p className="text-sm md:text-base text-slate-400 font-light leading-relaxed">
//                 {description}
//               </p>
//             )}
//           </div>

//           {/* شريط المسار والرجوع (Breadcrumbs) لسهولة التنقل */}
//           <div className="flex items-center gap-2 bg-slate-900/60 border border-slate-800/80 px-4 py-2 rounded-xl self-start md:self-auto text-xs md:text-sm whitespace-nowrap shadow-lg">
//             <a href="/" className="text-slate-400 hover:text-amber-400 transition-colors flex items-center gap-1">
//               <Home className="w-3.5 h-3.5" />
//               <span>الرئيسية</span>
//             </a>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-600" />
//             <a href="#services" className="text-slate-400 hover:text-amber-400 transition-colors">
//               خدماتنا
//             </a>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-600" />
//             <span className="text-amber-400 font-medium">{title}</span>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };





// import React, { useState } from 'react';
// import { ChevronLeft, Home, Briefcase, Scale, ChevronDown } from 'lucide-react';

// export const ServicePageHeader = ({ title, currentPath }) => {
//   const [activeTab, setActiveTab] = useState('corporate'); // 'corporate' أو 'litigation'

//   // بيانات الخدمات متطابقة تماماً مع الهيدر الرئيسي للموقع لضمان ثبات الروابط
//   const servicesData = {
//     corporate: {
//       title: 'قطاع الشركات والأعمال والاستثمار',
//       icon: <Briefcase className="w-4 h-4" />,
//       links: [
//         { name: 'الاستشارات القانونية', path: '/legal' },
//         { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//         { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//         { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//         { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//         { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//         { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//         { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//         { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//         { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//       ]
//     },
//     litigation: {
//       title: 'الخدمات القضائية والتصفية والتوثيق',
//       icon: <Scale className="w-4 h-4" />,
//       links: [
//         { name: 'الترافع والتقاضي', path: '/litigation' },
//         { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//         { name: 'الحراسة القضائية', path: '/judicial-custody' },
//         { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//         { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//         { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//         { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//         { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//         { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//         { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//       ]
//     }
//   };

//   // العثور على الوصف تلقائياً بناءً على اسم الخدمة الحالية المتمررة
//   const allLinks = [...servicesData.corporate.links, ...servicesData.litigation.links];
//   const currentService = allLinks.find(link => link.path === currentPath);

//   return (
//     <section className="relative pt-32 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 border-b border-slate-800/60 overflow-hidden" dir="rtl">
//       {/* التأثيرات الخلفية الفاخرة */}
//       <div className="absolute top-0 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none"></div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         {/* الجزء العلوي: العنوان والمسار */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-12">
//           <div className="max-w-3xl">
//             <span className="text-amber-500 text-xs md:text-sm font-semibold tracking-wider uppercase block mb-2">خدماتنا القانونية</span>
//             <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-3 tracking-wide">
//               {title}
//             </h1>
//           </div>

//           {/* شريط المسار Breadcrumbs */}
//           <div className="flex items-center gap-2 bg-slate-900/80 border border-slate-800 px-4 py-2 rounded-xl self-start md:self-auto text-xs md:text-sm shadow-xl">
//             <a href="/" className="text-slate-400 hover:text-amber-400 transition-colors flex items-center gap-1">
//               <Home className="w-3.5 h-3.5" />
//               <span>الرئيسية</span>
//             </a>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-700" />
//             <span className="text-slate-400">خدماتنا</span>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-700" />
//             <span className="text-amber-400 font-medium">{title}</span>
//           </div>
//         </div>

//         {/* الجزء السفلي الجديد: قائمة التصفح الداخلي السريع للـ 20 خدمة */}
//         <div className="border-t border-slate-800/80 pt-6 pb-4">
//           {/* أزرار التبديل بين القطاعين الكبيرين */}
//           <div className="flex gap-2 mb-6 bg-slate-950 p-1.5 rounded-xl border border-slate-800 max-w-md">
//             <button
//               onClick={() => setActiveTab('corporate')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-bold transition-all ${
//                 activeTab === 'corporate'
//                   ? 'bg-amber-500 text-slate-950 shadow-md shadow-amber-500/10'
//                   : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900'
//               }`}
//             >
//               {servicesData.corporate.icon}
//               <span>خدمات الشركات والأعمال</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('litigation')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-bold transition-all ${
//                 activeTab === 'litigation'
//                   ? 'bg-amber-500 text-slate-950 shadow-md shadow-amber-500/10'
//                   : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900'
//               }`}
//             >
//               {servicesData.litigation.icon}
//               <span>الخدمات القضائية والتوثيق</span>
//             </button>
//           </div>

//           {/* شبكة الروابط الـ 10 التابعة للقطاع النشط */}
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 animate-in fade-in duration-300">
//             {servicesData[activeTab].links.map((item) => {
//               const isCurrent = item.path === currentPath;
//               return (
//                 <a
//                   key={item.path}
//                   href={item.path}
//                   className={`px-3 py-2.5 rounded-xl text-xs md:text-sm font-medium border text-center transition-all duration-200 truncate ${
//                     isCurrent
//                       ? 'bg-slate-800 border-amber-500 text-amber-400 font-semibold shadow-inner'
//                       : 'bg-slate-900/40 border-slate-800/60 text-slate-400 hover:border-slate-700 hover:text-slate-200 hover:bg-slate-900'
//                   }`}
//                   title={item.name}
//                 >
//                   {item.name}
//                 </a>
//               );
//             })}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };



// import React, { useState } from 'react';
// import { ChevronLeft, Home, Briefcase, Scale, ChevronDown } from 'lucide-react';

// export const ServicePageHeader = ({ title, currentPath }) => {
//   const [activeTab, setActiveTab] = useState('corporate'); // 'corporate' أو 'litigation'

//   // بيانات الخدمات متطابقة تماماً مع الهيدر الرئيسي للموقع لضمان ثبات الروابط
//   const servicesData = {
//     corporate: {
//       title: 'قطاع الشركات والأعمال والاستثمار',
//       icon: <Briefcase className="w-4 h-4" />,
//       links: [
//         { name: 'الاستشارات القانونية', path: '/legal' },
//         { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//         { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//         { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//         { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//         { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//         { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//         { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//         { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//         { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//       ]
//     },
//     litigation: {
//       title: 'الخدمات القضائية والتصفية والتوثيق',
//       icon: <Scale className="w-4 h-4" />,
//       links: [
//         { name: 'الترافع والتقاضي', path: '/litigation' },
//         { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//         { name: 'الحراسة القضائية', path: '/judicial-custody' },
//         { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//         { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//         { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//         { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//         { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//         { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//         { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//       ]
//     }
//   };

//   // العثور على الوصف تلقائياً بناءً على اسم الخدمة الحالية المتمررة
//   const allLinks = [...servicesData.corporate.links, ...servicesData.litigation.links];
//   const currentService = allLinks.find(link => link.path === currentPath);

//   return (
//     <section className="relative pt-36 pb-8 bg-gradient-to-b from-slate-50 via-white to-slate-50 border-b border-slate-100 overflow-hidden" dir="rtl">
//       {/* التأثيرات الخلفية الفاخرة الهادئة للنمط الفاتح */}
//       <div className="absolute top-0 right-1/4 w-96 h-96 bg-indigo-950/[0.01] rounded-full blur-3xl pointer-events-none"></div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         {/* الجزء العلوي: العنوان والمسار */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-10">
//           <div className="max-w-3xl">
//             <span className="text-blue-700 text-xs md:text-sm font-bold tracking-wider uppercase block mb-2">خدماتنا القانونية</span>
//             <h1 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-1 tracking-wide">
//               {title}
//             </h1>
//           </div>

//           {/* شريط المسار Breadcrumbs - Navy Light Style */}
//           <div className="flex items-center gap-2 bg-white border border-slate-100 px-4 py-2 rounded-xl self-start md:self-auto text-xs md:text-sm shadow-sm">
//             <a href="/" className="text-slate-500 hover:text-blue-700 font-medium transition-colors flex items-center gap-1">
//               <Home className="w-3.5 h-3.5 text-slate-400" />
//               <span>الرئيسية</span>
//             </a>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
//             <span className="text-slate-500 font-medium">خدماتنا</span>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
//             <span className="text-indigo-950 font-bold">{title}</span>
//           </div>
//         </div>

//         {/* الجزء السفلي الجديد: قائمة التصفح الداخلي السريع للـ 20 خدمة بالنمط المؤسسي الفخم */}
//         <div className="border-t border-slate-200/60 pt-6">
//           {/* أزرار التبديل بين القطاعين الكبيرين بنظام ألوان معزز وعصري */}
//           <div className="flex gap-2 mb-6 bg-slate-100/70 p-1.5 rounded-xl border border-slate-200/60 max-w-md">
//             <button
//               onClick={() => setActiveTab('corporate')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
//                 activeTab === 'corporate'
//                   ? 'bg-indigo-950 text-white shadow-sm'
//                   : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
//               }`}
//             >
//               {servicesData.corporate.icon}
//               <span>خدمات الشركات والأعمال</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('litigation')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
//                 activeTab === 'litigation'
//                   ? 'bg-indigo-950 text-white shadow-sm'
//                   : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
//               }`}
//             >
//               {servicesData.litigation.icon}
//               <span>الخدمات القضائية والتوثيق</span>
//             </button>
//           </div>

//           {/* شبكة الروابط الـ 10 التابعة للقطاع النشط بنمط ألوان خفيف ونظيف */}
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 animate-in fade-in duration-300">
//             {servicesData[activeTab].links.map((item) => {
//               const isCurrent = item.path === currentPath;
//               return (
//                 <a
//                   key={item.path}
//                   href={item.path}
//                   className={`px-3 py-2.5 rounded-xl text-xs md:text-sm font-semibold border text-center transition-all duration-200 truncate ${
//                     isCurrent
//                       ? 'bg-blue-50/50 border-indigo-950 text-indigo-950 font-bold shadow-sm'
//                       : 'bg-white border-slate-100 text-slate-600 hover:border-slate-300 hover:text-indigo-950 hover:bg-slate-50/80 shadow-sm'
//                   }`}
//                   title={item.name}
//                 >
//                   {item.name}
//                 </a>
//               );
//             })}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };


// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, Home, Briefcase, Scale, ChevronDown } from 'lucide-react';

// export const ServicePageHeader = ({ title, currentPath }) => {
//   const [activeTab, setActiveTab] = useState('corporate'); // الديفولت هو قطاع الشركات

//   // بيانات الخدمات متطابقة تماماً مع الهيدر الرئيسي للموقع لضمان ثبات الروابط
//   const servicesData = {
//     corporate: {
//       title: 'قطاع الشركات والأعمال والاستثمار',
//       icon: <Briefcase className="w-4 h-4" />,
//       links: [
//         { name: 'الاستشارات القانونية', path: '/legal' },
//         { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//         { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//         { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//         { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//         { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//         { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//         { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//         { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//         { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//       ]
//     },
//     litigation: {
//       title: 'الخدمات القضائية والتصفية والتوثيق',
//       icon: <Scale className="w-4 h-4" />,
//       links: [
//         { name: 'الترافع والتقاضي', path: '/litigation' },
//         { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//         { name: 'الحراسة القضائية', path: '/judicial-custody' },
//         { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//         { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//         { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//         { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//         { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//         { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//         { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//       ]
//     }
//   };

//   // تأثير جانبي يقوم بفحص الرابط الحالي تلقائياً وتحديد التبويب الصحيح بناءً عليه عند التحميل
//   useEffect(() => {
//     if (currentPath) {
//       const isInLitigation = servicesData.litigation.links.some(link => link.path === currentPath);
//       if (isInLitigation) {
//         setActiveTab('litigation');
//       } else {
//         setActiveTab('corporate');
//       }
//     }
//   }, [currentPath]);

//   return (
//     <section className="relative pt-36 pb-8 bg-gradient-to-b from-slate-50 via-white to-slate-50 border-b border-slate-100 overflow-hidden" dir="rtl">
//       {/* التأثيرات الخلفية الفاخرة الهادئة للنمط الفاتح */}
//       <div className="absolute top-0 right-1/4 w-96 h-96 bg-indigo-950/[0.01] rounded-full blur-3xl pointer-events-none"></div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         {/* الجزء العلوي: العنوان والمسار */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-10">
//           <div className="max-w-3xl">
//             <span className="text-blue-700 text-xs md:text-sm font-bold tracking-wider uppercase block mb-2">خدماتنا القانونية</span>
//             <h1 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-1 tracking-wide">
//               {title}
//             </h1>
//           </div>

//           {/* شريط المسار Breadcrumbs - Navy Light Style */}
//           <div className="flex items-center gap-2 bg-white border border-slate-100 px-4 py-2 rounded-xl self-start md:self-auto text-xs md:text-sm shadow-sm">
//             <a href="/" className="text-slate-500 hover:text-blue-700 font-medium transition-colors flex items-center gap-1">
//               <Home className="w-3.5 h-3.5 text-slate-400" />
//               <span>الرئيسية</span>
//             </a>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
//             <span className="text-slate-500 font-medium">خدماتنا</span>
//             <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
//             <span className="text-indigo-950 font-bold">{title}</span>
//           </div>
//         </div>

//         {/* الجزء السفلي: قائمة التصفح الداخلي السريع للـ 20 خدمة بالنمط المؤسسي الفخم */}
//         <div className="border-t border-slate-200/60 pt-6">
//           {/* أزرار التبديل بين القطاعين الكبيرين بنظام ألوان معزز وعصري */}
//           <div className="flex gap-2 mb-6 bg-slate-100/70 p-1.5 rounded-xl border border-slate-200/60 max-w-md">
//             <button
//               onClick={() => setActiveTab('corporate')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
//                 activeTab === 'corporate'
//                   ? 'bg-indigo-950 text-white shadow-sm'
//                   : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
//               }`}
//             >
//               {servicesData.corporate.icon}
//               <span>خدمات الشركات والأعمال</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('litigation')}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
//                 activeTab === 'litigation'
//                   ? 'bg-indigo-950 text-white shadow-sm'
//                   : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
//               }`}
//             >
//               {servicesData.litigation.icon}
//               <span>الخدمات القضائية والتوثيق</span>
//             </button>
//           </div>

//           {/* شبكة الروابط الـ 10 التابعة للقطاع النشط بنمط ألوان خفيف ونظيف */}
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 animate-in fade-in duration-300">
//             {servicesData[activeTab].links.map((item) => {
//               const isCurrent = item.path === currentPath;
//               return (
//                 <a
//                   key={item.path}
//                   href={item.path}
//                   className={`px-3 py-2.5 rounded-xl text-xs md:text-sm font-semibold border text-center transition-all duration-200 truncate ${
//                     isCurrent
//                       ? 'bg-blue-50/50 border-indigo-950 text-indigo-950 font-bold shadow-sm'
//                       : 'bg-white border-slate-100 text-slate-600 hover:border-slate-300 hover:text-indigo-950 hover:bg-slate-50/80 shadow-sm'
//                   }`}
//                   title={item.name}
//                 >
//                   {item.name}
//                 </a>
//               );
//             })}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };


import React, { useState, useEffect } from 'react';
import { ChevronLeft, Home, Briefcase, Scale } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
export const ServicePageHeader = ({ title }) => {
  // 1. نجعل الحالة الابتدائية تكتشف الرابط الحالي فوراً قبل حتى عملية الـ Render لمنع الـ Flicker البصري
  const getCurrentTabFromURL = () => {
    const currentPathname = window.location.pathname; // يقرأ الرابط من المتصفح مباشرة مثل '/arbitration'
    
    // قائمة مسارات الخدمات القضائية
    const litigationPaths = [
      '/litigation', '/arbitration', '/judicial-custody', '/execution', 
      '/debt-collection', '/estate-liquidation', '/waqf-will', 
      '/real-estate-registration', '/documentation', '/legal-research-regulations'
    ];

    if (litigationPaths.includes(currentPathname)) {
      return 'litigation';
    }
    return 'corporate';
  };

  const [activeTab, setActiveTab] = useState(getCurrentTabFromURL);

  // بيانات الخدمات متطابقة تماماً مع الهيدر الرئيسي للموقع لضمان ثبات الروابط
  const servicesData = {
    corporate: {
      title: 'قطاع الشركات والأعمال والاستثمار',
      icon: <Briefcase className="w-4 h-4" />,
      links: [
        { name: 'الاستشارات القانونية', path: '/legal' },
        { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
        { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
        { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
        { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
        { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
        { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
        { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
        { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
        { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
      ]
    },
    litigation: {
      title: 'الخدمات القضائية والتصفية والتوثيق',
      icon: <Scale className="w-4 h-4" />,
      links: [
        { name: 'الترافع والتقاضي', path: '/litigation' },
        { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
        { name: 'الحراسة القضائية', path: '/judicial-custody' },
        { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
        { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
        { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
        { name: 'الأوقاف والوصايا', path: '/waqf-will' },
        { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
        { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
        { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
      ]
    }
  };

  // تحديث التبويب تلقائياً في حال تغير الرابط بدون إعادة تحميل (إذا كنت تستخدم React Router Link مستقبلاً)
  useEffect(() => {
    setActiveTab(getCurrentTabFromURL());
  }, []);

  return (
    <section className="relative pt-6 pb-8 bg-gradient-to-b from-slate-50 via-white to-slate-50 border-b border-slate-100 overflow-hidden" dir="rtl">
      <Helmet>
        <title>خدمات الشركات الناشئة وريادة الأعمال | مكتبنا القانوني</title>
        <meta name="description" content="نقدم صياغة اتفاقيات الشركاء، هيكلة جولات التمويل الجريء، عقود  وحماية الملكية الفكرية للشركات الناشئة في السوق السعودي." />
        <link rel="canonical" href={`https://nrfirm.com/${title}`} />
        <meta property="og:title" content="خدمات الشركات الناشئة وريادة الأعمال | مكتبنا القانوني" />
        <meta property="og:url" content={`https://nrfirm.com/${title}`} />
      </Helmet>
    {/* <section className="relative pt-36 pb-8 bg-gradient-to-b from-slate-50 via-white to-slate-50 border-b border-slate-100 overflow-hidden" dir="rtl"> */}
      {/* التأثيرات الخلفية الفاخرة الهادئة للنمط الفاتح */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-indigo-950/[0.01] rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* الجزء العلوي: العنوان والمسار */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-10">
          <div className="max-w-3xl">
            <span className="text-blue-700 text-xs md:text-sm font-bold tracking-wider uppercase block mb-2">خدماتنا القانونية</span>
            <h1 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-1 tracking-wide">
              {title}. 
            </h1>
          </div>

          {/* شريط المسار Breadcrumbs - Navy Light Style */}
          <div className="flex items-center gap-2 bg-white border border-slate-100 px-4 py-2 rounded-xl self-start md:self-auto text-xs md:text-sm shadow-sm">
            <a href="/" className="text-slate-500 hover:text-blue-700 font-medium transition-colors flex items-center gap-1">
              <Home className="w-3.5 h-3.5 text-slate-400" />
              <span>الرئيسية</span>
            </a>
            <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
            <span className="text-slate-500 font-medium">خدماتنا</span>
            <ChevronLeft className="w-3.5 h-3.5 text-slate-300" />
            <span className="text-indigo-950 font-bold">{title}</span>
          </div>
        </div>

        {/* الجزء السفلي: قائمة التصفح الداخلي السريع للـ 20 خدمة بالنمط المؤسسي الفخم */}
        {/* <div className="border-t border-slate-200/60 pt-6"> */}
          {/* أزرار التبديل بين القطاعين الكبيرين بنظام ألوان معزز وعصري */}
          {/* <div className="flex gap-2 mb-6 bg-slate-100/70 p-1.5 rounded-xl border border-slate-200/60 max-w-md">
            <button
              onClick={() => setActiveTab('corporate')}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
                activeTab === 'corporate'
                  ? 'bg-indigo-950 text-white shadow-sm'
                  : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
              }`}
            >
              {servicesData.corporate.icon}
              <span>خدمات الشركات والأعمال</span>
            </button>
            <button
              onClick={() => setActiveTab('litigation')}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-xs md:text-sm font-extrabold transition-all duration-200 ${
                activeTab === 'litigation'
                  ? 'bg-indigo-950 text-white shadow-sm'
                  : 'text-slate-600 hover:text-indigo-950 hover:bg-white/60'
              }`}
            >
              {servicesData.litigation.icon}
              <span>الخدمات القضائية والتوثيق</span>
            </button>
          </div> */}

          {/* شبكة الروابط الـ 10 التابعة للقطاع النشط بنمط ألوان خفيف ونظيف */}
          {/* <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 animate-in fade-in duration-300">
            {servicesData[activeTab].links.map((item) => {
              // التحقق من أن هذا الخيار هو الصفحة الحالية المفتوحة في المتصفح بالفعل
              const isCurrent = item.path === window.location.pathname;
              return (
                <a
                  key={item.path}
                  href={item.path}
                  className={`px-3 py-2.5 rounded-xl text-xs md:text-sm font-semibold border text-center transition-all duration-200 truncate ${
                    isCurrent
                      ? 'bg-blue-50/50 border-indigo-950 text-indigo-950 font-bold shadow-sm'
                      : 'bg-white border-slate-100 text-slate-600 hover:border-slate-300 hover:text-indigo-950 hover:bg-slate-50/80 shadow-sm'
                  }`}
                  title={item.name}
                >
                  {item.name}
                </a>
              );
            })}
          </div> */}
        </div>

      {/* </div> */}
    </section>
  );
};